module.exports = __webpack_public_path__ + "img/zephyros_memorial_small.844801d6.png";